/* Vortex Corner — animations. Vanilla JS, sans dépendance.
   Shopify : assets/vx-motion.js, dans layout/theme.liquid :
   <script src="{{ 'vx-motion.js' | asset_url }}" defer></script>
   Crochets (à poser dans les sections Liquid) :
   data-vx-logo · data-vx-reveal-group · data-vx-hover · data-vx-add (bouton ajouter au panier) · data-vx-cart-btn
   data-vx-drawer · data-vx-backdrop · data-vx-popup · data-vx-clubtab · data-vx-opt-on (option active) · data-vx-shipbar · data-vx-loupe (+ data-vx-loupe-src HD)
   Fermeture du tiroir / de la pop-up : window.vxClose(conteneur, () => conteneur.hidden = true) */
(function () {
  if (window.__vxMotion) return; window.__vxMotion = true;
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var EASE = 'cubic-bezier(0.22,1,0.36,1)';

  try { root.setAttribute('data-vx-intro', sessionStorage.getItem('vx-intro') ? 'short' : 'full'); sessionStorage.setItem('vx-intro', '1'); }
  catch (e) { root.setAttribute('data-vx-intro', 'full'); }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    var n = 0;
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, i = Math.min(n++, 8);
      el.style.setProperty('--vx-i', i);
      el.setAttribute('data-vx-in', '');
      io.unobserve(el);
      setTimeout(function () { el.style.setProperty('--vx-i', 0); }, i * 50 + 700);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }) : null;

  function arm(el) {
    if (!io || reduce.matches || el.hasAttribute('data-vx-reveal')) return;
    el.setAttribute('data-vx-reveal', '');
    io.observe(el);
  }
  function scan() {
    var groups = d.querySelectorAll('[data-vx-reveal-group]');
    for (var i = 0; i < groups.length; i++) for (var c = groups[i].firstElementChild; c; c = c.nextElementSibling) arm(c);
  }

  function anim(el, frames, ms) { if (el && el.animate && !reduce.matches) el.animate(frames, { duration: ms, easing: EASE }); }

  // Navigation sans rechargement (aperçu, ou thème en AJAX) : le logo est aspiré à chaque changement de page.
  // Pop-up Club : l'animation du logo se joue en entier à chaque ouverture.
  var lastClub = null;
  function checkClub() {
    var c = d.querySelector('[data-vx-club-logo]');
    if (c && c !== lastClub && window.VXLogo) window.VXLogo.play(c, { duration: 6 });
    lastClub = c;
  }
  var lastMain = null;
  function checkMain() {
    var m = d.querySelector('main');
    if (m && m !== lastMain) {
      var lg = d.querySelector('[data-vx-header] [data-vx-logo-anim]');
      if (lg && window.VXLogo) window.VXLogo.play(lg, { duration: !lastMain && root.getAttribute('data-vx-intro') === 'full' ? 6 : 2.4 });
      lastMain = m;
    }
  }

  // Ajout au panier : pression du bouton + impulsion sur le bouton panier de l'en-tête.
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vx-add]');
    if (!b) return;
    anim(b, [{ transform: 'scale(1)' }, { transform: 'scale(.95)' }, { transform: 'scale(1)' }], 150);
    anim(d.querySelector('[data-vx-cart-btn]'), [{ transform: 'scale(1)' }, { transform: 'scale(1.14)', offset: .35 }, { transform: 'scale(1)' }], 360);
  }, true);

  // Sortie animée pour les thèmes : vxClose(conteneur, callback) pose data-vx-closing, attend la fin puis masque.
  window.vxClose = function (el, done) {
    if (!el) return; if (reduce.matches) { done && done(); return; }
    el.setAttribute('data-vx-closing', 'true');
    setTimeout(function () { el.removeAttribute('data-vx-closing'); done && done(); }, 340);
  };

  // Loupe atelier : [data-vx-loupe] autour de l'image produit, data-vx-loupe-src = fichier HD.
  // Shopify : data-vx-loupe-src="{{ product.featured_media | image_url: width: 3000 }}"
  (function () {
    var lens, inner, label, host = null, img = null, hd = {}, zA = 3, zB = 5, zoom = 3, R = 110;
    var active = false, touchMode = false, tx = 0, ty = 0, cx = 0, cy = 0, raf = 0, holdT = 0, sx = 0, sy = 0;
    var fine = window.matchMedia ? matchMedia('(hover: hover) and (pointer: fine)') : { matches: true };
    function build() {
      if (lens) return;
      lens = d.createElement('div'); lens.setAttribute('data-vx-lens', ''); lens.setAttribute('aria-hidden', 'true');
      inner = d.createElement('img'); inner.alt = ''; inner.decoding = 'async'; inner.draggable = false;
      label = d.createElement('span'); lens.appendChild(inner); lens.appendChild(label); d.body.appendChild(lens);
    }
    function hostOf(t) { return t && t.closest ? t.closest('[data-vx-loupe]') : null; }
    function imgOf(h) { return h.querySelector('img'); }
    function inside(i, x, y) { var r = i.getBoundingClientRect(); return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom; }
    function srcOf(h, i) { return h.getAttribute('data-vx-loupe-src') || i.currentSrc || i.src; }
    function fit() {
      // Zoom calé sur la définition réelle du fichier : jamais d'agrandissement flou au-delà de ~1,5× le natif.
      var r = img.getBoundingClientRect(), p = hd[inner.dataset.want], nat = (p && p.w) || img.naturalWidth || r.width;
      var ratio = nat / r.width;
      zA = Math.max(1.8, Math.min(3, ratio * 1.4)); zB = Math.max(zA + 0.6, Math.min(5, ratio * 2.2));
      if (zoom !== zA && zoom !== zB) zoom = zA;
      inner.style.width = r.width * zoom + 'px'; inner.style.height = r.height * zoom + 'px';
      label.textContent = (p && p.ready ? 'HD · ' : 'Chargement HD… · ') + '×' + (Math.round(zoom * 10) / 10);
    }
    function loadHD(src) {
      if (hd[src]) return hd[src];
      var p = hd[src] = { ready: false, w: 0 }, im = new Image(); im.decoding = 'async';
      im.onload = function () { p.ready = true; p.w = im.naturalWidth; if (active && inner.dataset.want === src) { inner.src = src; fit(); move(tx, ty, true); } };
      im.src = src; return p;
    }
    function begin(h, x, y, touch) {
      var i = imgOf(h); if (!i) return; build();
      host = h; img = i; touchMode = touch; active = true; zoom = 0;
      var src = srcOf(h, i), p = loadHD(src); inner.dataset.want = src; inner.src = p.ready ? src : (i.currentSrc || i.src);
      fit(); h.setAttribute('data-vx-loupe-on', ''); lens.setAttribute('data-on', ''); move(x, y, true);
    }
    function move(x, y, snap) { if (!active) return; tx = x; ty = y; if (snap || reduce.matches) { cx = x; cy = y; if (raf) { cancelAnimationFrame(raf); raf = 0; } step(); return; } if (!raf) raf = requestAnimationFrame(step); }
    function step() {
      raf = 0; if (!active) return;
      cx += (tx - cx) * 0.38; cy += (ty - cy) * 0.38;
      if (Math.abs(tx - cx) < 0.3 && Math.abs(ty - cy) < 0.3) { cx = tx; cy = ty; }
      var r = img.getBoundingClientRect();
      var px = Math.min(Math.max(cx, r.left), r.right), py = Math.min(Math.max(cy, r.top), r.bottom);
      var ly = touchMode ? py - R - 48 : py; // au doigt, la loupe passe au-dessus pour rester visible
      lens.style.translate = (px - R) + 'px ' + (ly - R) + 'px'; // translate (pas transform) : appliqué avant scale, la lentille grossit sur place
      inner.style.transform = 'translate3d(' + (R - (px - r.left) * zoom) + 'px,' + (R - (py - r.top) * zoom) + 'px,0)';
      if (cx !== tx || cy !== ty) raf = requestAnimationFrame(step);
    }
    function end() { if (!active) return; active = false; if (host) host.removeAttribute('data-vx-loupe-on'); if (lens) lens.removeAttribute('data-on'); host = img = null; }

    d.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !fine.matches) return;
      var h = hostOf(e.target), i = h && imgOf(h);
      if (i && inside(i, e.clientX, e.clientY)) { if (!active || host !== h) begin(h, e.clientX, e.clientY, false); else move(e.clientX, e.clientY); }
      else if (!touchMode) end();
    }, { passive: true });
    d.documentElement.addEventListener('mouseleave', function () { if (!touchMode) end(); });
    // Un seul niveau de grossissement (le second niveau, jusqu'à ×5, a été retiré à la demande du client)
    window.addEventListener('scroll', function () { if (active && !touchMode) end(); }, { passive: true });

    d.addEventListener('touchstart', function (e) {
      var h = hostOf(e.target); if (!h || e.touches.length > 1) return;
      var t = e.touches[0]; sx = t.clientX; sy = t.clientY; clearTimeout(holdT);
      holdT = setTimeout(function () { var i = imgOf(h); if (i && inside(i, sx, sy)) begin(h, sx, sy, true); }, 240);
    }, { passive: true });
    d.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (active && touchMode) { if (e.cancelable) e.preventDefault(); move(t.clientX, t.clientY); }
      else if (Math.abs(t.clientX - sx) > 8 || Math.abs(t.clientY - sy) > 8) clearTimeout(holdT);
    }, { passive: false });
    function tEnd() { clearTimeout(holdT); if (touchMode) { end(); touchMode = false; } }
    d.addEventListener('touchend', tEnd); d.addEventListener('touchcancel', tEnd);
    d.addEventListener('contextmenu', function (e) { if (hostOf(e.target) && (active || holdT)) e.preventDefault(); });
  })();

  var queued = false;
  function tick() { queued = false; scan(); checkMain(); checkClub(); }
  function start() {
    tick();
    new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(tick); } }).observe(d.body, { childList: true, subtree: true });
  }
  function boot() { if (d.body) start(); else setTimeout(boot, 30); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
